import { replace } from 'redux-first-history';
import { SagaIterator } from 'redux-saga';
import { getCurrentLocation } from 'src/modules/routing/selectors/getCurrentLocation';
import { put, select } from 'typed-redux-saga';

export function* restoreCurrentUrl(): SagaIterator<void> {
  const location = yield* select(getCurrentLocation);
  yield* put(location ? replace(location) : replace('/'));
}
